import { list } from "@mc/mc-legacy";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
export const POZADAVEK_NEVYRIZENE_LIST = "pozadavekNevyrizeneList";

const getRequestsByIds = (ids) => {
  return QSignDataApi.findRequestsByIds(ids);
};

const getAllPozadavkyIds = () => {
  return QSignDataApi.findNevyrizenePozadavkyPredkladatel();
};
const getPozadavkyIdsPodepisujiciSchvalovatel = (podepisujiciId: number, schvalovatelId: number) => {
    return QSignDataApi.findNevyrizenePozadavkyPredkladatelAndPodepisujiciSchvalovatel(podepisujiciId, schvalovatelId);
};
export function fetchIfNeeded(forceFetch) {
  return (dispatch) => {
    dispatch(
      list.InfiniteListActions.fetchIfNeeded(
        POZADAVEK_NEVYRIZENE_LIST,
        null,
        getAllPozadavkyIds,
        getRequestsByIds,
        forceFetch
      )
    );
  };
}
export function fetchPodepisujiciSchvalovatel(pracovnikId: number, forceFetch: boolean) {
    return (dispatch) => {
        dispatch(
            list.InfiniteListActions.fetchIfNeeded(
                POZADAVEK_NEVYRIZENE_LIST,
                null,
                () => getPozadavkyIdsPodepisujiciSchvalovatel(pracovnikId, pracovnikId),
                getRequestsByIds,
                forceFetch
            )
        );
    };
}
export function loadMore() {
  return (dispatch, getState) => {
    dispatch(list.InfiniteListActions.loadMore(POZADAVEK_NEVYRIZENE_LIST, getRequestsByIds));
  };
}
export function invalidate() {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.invalidate(POZADAVEK_NEVYRIZENE_LIST));
  };
}
